import { render, staticRenderFns } from "./Lots.vue?vue&type=template&id=8240e11c&"
import script from "./Lots.vue?vue&type=script&lang=js&"
export * from "./Lots.vue?vue&type=script&lang=js&"
import style0 from "./Lots.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports